import { Navigate } from 'react-router-dom';
import { useSession } from '../hooks/useSession.tsx';
import { useT } from '../i18n/index.ts';

/**
 * `/` entry redirect — Field Notes rebuild (epic #950 PR-4, formerly
 * the console-shared `createRootRedirect` factory instantiation;
 * identical behavior).
 */
export function RootRedirect(): JSX.Element {
  const { status } = useSession();
  const t = useT();

  if (status === 'loading') {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-canvas px-8 text-body text-ink-low"
        role="status"
        aria-live="polite"
      >
        <p>{t('common.session.checking')}</p>
      </div>
    );
  }

  if (status === 'authenticated') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
}
